// filepath: apps/web/src/features/admin/templates/update/TemplateUpdateRoute.tsx
//
// FR-UI-ADM-12 AC-2..AC-8 — route shell for the template-update
// diff view at /admin/templates/updates/:templateId.
//
// Reads ONLY the `installed` and `target` query parameters from
// the URL. No other query-param is honoured — the non-skippable
// surface forbids `?skip` / `?auto_apply` / `?bypass_review`
// handlers (mirrors FR-UI-PROM-2 non-skippable pattern).

import React from "react";
import { TemplateUpdatePage } from "./TemplateUpdatePage";

interface TemplateUpdateRouteProps {
  templateId: string;
  installed: string;
  target: string;
  /** Click handler for the irreversible-redirect path (AC-8). */
  onRedirect?: (reviewId: string) => void;
}

export function TemplateUpdateRoute({
  templateId,
  installed,
  target,
  onRedirect,
}: TemplateUpdateRouteProps): React.ReactElement {
  return (
    <TemplateUpdatePage
      templateId={templateId}
      installed={installed}
      target={target}
      onRedirect={onRedirect}
    />
  );
}
